import React from 'react';
import moment from "moment";
import { createContext, useContext, useEffect, useState } from "react";
import { useFilterContext } from "../../../hooks/FilterContext";
import { useAdministrationFeesProvider } from "../../../hooks/AdministrationFeesContext";
import { useLazySearchDebtorsQuery } from "../../../services/headofficeadmin";

const SearchDebtorsContext = createContext();

export const useSearchDebtors = () => useContext(SearchDebtorsContext);


const SearchDebtorsProvider = ({ children, searchType }) => {

    //const [sort, setSort] = useState("feeDate+ASC");
    const [sort, setSort] = useState("feeDate+DESC");
    const [pageLimit, setPageLimit] = useState(25);
    const [cacheKey, setCacheKey] = useState(new Date().valueOf());
    const [isLoadingState, setIsLoadingState] = React.useState(false);
    
    const { filter, isReady } = useFilterContext();
    const [searchTrigger, { data, isLoading, isFetching, isError, error, isUninitialized }] = useLazySearchDebtorsQuery();

    const { pagination, results, newRecordsSinceCache } = data || { pagination: { page: 1, pageSize: pageLimit, totalCount: 0, totalPages: 1 }, results: [], newRecordsSinceCache: 0 };
    const { page, pageSize, totalCount, totalPages } = pagination;
    const hasMore = totalCount > 0 && page < totalPages;
    const isNextPageLoading = isFetching === true || isLoading === true || isLoadingState === true;
    
    ////const { hasMore, results, pagination } = data || { results: [], pagination: {page: 0}, hasMore: true };
    //const { hasMore, results, pagination } = data || { results: [], pagination: {page: 1}, hasMore: true };
    //const { page } = pagination || { page: 1 }; 
    ////const { filters, currentSearchType } = useAdministrationFeesProvider();
    //const isNextPageLoading = isFetching === true || isLoading === true;
    //const [isClearing, setIsClearing] = useState(false);

    
    //console.log('debtors search filters ',filter,);
    //console.log('debtors hook hasMore',hasMore,);

    const clear = () => {
        if (isNextPageLoading || !isReady) {
            return;
        }
        const newCacheKey = new Date().valueOf();
        setIsLoadingState(_ => true);
        //setIsClearing(true);
        searchTrigger({
            cacheKey: newCacheKey,
            //searchType:currentSearchType,
            filter:{...filter,
                adviserIds: filter.advisers?.map(x => x.value) ?? [],
                introducerIds: filter.introducers?.map(x => x.value) ?? [],
                masterAccountIds: filter.masterAccounts?.map(x => x.value) ?? [],
                //feeTypes: filter.feeTypes?.map(x => x.value) ?? [],
                providerIds: filter.providers?.map(x => x.value) ?? [],
                debtOnDate: filter.debtOnDate ?? moment().format('YYYY/MM/DD'),
                limit: pageLimit,
                page: 1,
                sort}
        })
        .unwrap()
        .then(
            _ => {
                setCacheKey(_prev => newCacheKey);   
            }
        )
        .finally(setIsLoadingState(_prev => false));//.finally(() => setIsClearing(false));
    };

    const isItemLoaded = (index) => index < results.length || results[index];
    //const isRowLoaded = (index) => !hasMore || index < results.length;
    const isRowLoaded = (index) => results[index] || index < results.length;

    const loadMoreItems = () => {
        if (isNextPageLoading) {
            return;
        }
        setIsLoadingState(_ => true);
        searchTrigger({
            cacheKey,
            //searchType:currentSearchType,
            filter:{...filter,
            adviserIds: filter.advisers?.map(x => x.value) ?? [],
            introducerIds: filter.introducers?.map(x => x.value) ?? [],
            masterAccountIds: filter.masterAccounts?.map(x => x.value) ?? [],
            //feeTypes: filter.feeTypes?.map(x => x.value) ?? [],
            providerIds: filter.providers?.map(x => x.value) ?? [],
            debtOnDate: filter.debtOnDate ?? moment().format('YYYY/MM/DD'),
            limit: pageLimit,
            page: page + 1,
            sort}
        })
        .unwrap()
        .finally(setIsLoadingState(_prev => false));
    };

    const retrySearchDebtors = (e) => {
        if (isUninitialized || !isReady || isNextPageLoading ) return; //added
        if (e && typeof (e) === "function") {
            e.preventDefault();
        }

        clear();
    };

    const updateSort = (property) => {
        const [oldProperty, direction] = sort.split("+");

        if (oldProperty === property) {
            return setSort(`${property}+${direction === "ASC" ? "DESC" : "ASC"}`)
        }

        setSort(`${property}+DESC`);
    };

    useEffect(() => {
        //if (isUninitialized) return;
        clear();
    }, [sort, filter, isReady]);

    //console.log('debtor data from hook ',results);

    return <SearchDebtorsContext.Provider value={{
        results: results || [],
        //totalCount: results.length > 0 && hasMore ? results.length + limit : results.length,   
        //isClearing, 
        error,
        isError,
        sort,
        clear,
        hasMore,
        isLoading,
        isFetching,
        isNextPageLoading,
        isNewRecords: newRecordsSinceCache > 0,
        isItemLoaded,
        isRowLoaded,
        limit: pageLimit,
        loadMoreItems: isNextPageLoading ? () => {} : loadMoreItems,
        retrySearchDebtors,
        page,
        pagination,
        updateSort,
        totalCount,
        totalPages
    }}>
        {children}
    </SearchDebtorsContext.Provider>
};

export default SearchDebtorsProvider;
